/*自定义表单规则*/
function positiveNumber(rule, value, callback) { //判断是否是正整数
    if (value === ''){
        return callback(new Error('输入数据不能为空'))
    } //判断为空返回错误
    const r = /^\+?[1-9][0-9]*$/; // 正整数
    // 如果判断不符合正则，则不是正整数不能提交
    if (!r.test(value)){
        return callback(new Error('输入数据必须为正整数'))
    }else {
        return callback()
    }
}

module.exports = {
    positiveNumber
}
